import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import type { Tables } from "@/integrations/supabase/types";

interface AvailableFieldsProps {
  fields: Pick<Tables<"fields">, "id" | "name">[] | undefined;
  onAddField: (fieldId: string) => void;
  disabledFields: string[];
}

export const AvailableFields = ({ fields, onAddField, disabledFields }: AvailableFieldsProps) => {
  return (
    <div className="border rounded-lg p-4">
      <h4 className="text-sm font-medium mb-2">Available Fields</h4>
      <div className="grid gap-2">
        {fields?.map((field) => (
          <Button
            key={field.id}
            variant="outline"
            className="w-full justify-start"
            onClick={() => onAddField(field.id)}
            disabled={disabledFields.includes(field.id)}
          >
            <Plus className="mr-2 h-4 w-4" />
            {field.name}
          </Button>
        ))}
      </div>
    </div>
  );
};
